import { useInfiniteQuery } from '@tanstack/react-query';
export const useNewsQuery = (year) => {
    return useInfiniteQuery(['news'], async ({ pageParam = 1 }) => {
        const params = new URLSearchParams();
        params.append('page', pageParam);
        params.append('year', year);
        try {
            const response = await fetch(`/api/news?${params}`);
            return await response.json();
        }
        catch (error) {
            return error;
        }
    }, {
        getNextPageParam: (prevState) => {
            return (prevState.current_page + 1 > prevState.last_page) ? undefined : prevState.current_page + 1;
        },
    });
};
